import React from 'react';
import logoBottom from '../../images/Ulysses25New.png';
const ulylogoBottomTaskview = (props) => (
    <img style={{ width: '180px', float: 'right' }} src={logoBottom} />

);
export default ulylogoBottomTaskview;




// WEBPACK FOOTER //
// ./src/components/Logo/logoUlyssesTaskView.js